import { render, staticRenderFns } from "./UiRadioGroup.vue?vue&type=template&id=9b4c6490"
import script from "./UiRadioGroup.vue?vue&type=script&lang=js"
export * from "./UiRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./UiRadioGroup.vue?vue&type=style&index=0&id=9b4c6490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports